export default __webpack_public_path__ + "static/media/iconeDoc.734c79f2.png";